import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class ImageElement extends AbstractBlock {
  constructor() {
    super('image_v2', t.to('画像パネルブロック', 'image_panel'));
    this.setNameForCode('a-image');
  }

  toXmlFromSubBlockCustom(dom: HTMLElement): void {
    dom.appendChild(ShapeSettings.getColorInputValueXML());
  }

  defineBlock(block: BlockType): void {
    // ブロックの属性をセット
    ColorSettings.setObjectColor(block);
    ShapeSettings.setElementShape(block);

    ShapeSettings.setTitleField(block, this.title);

    const pathText = new Blockly.FieldTextInput('');
    block.appendDummyInput().appendField(pathText, 'path');

    ShapeSettings.setIdField(block);
    block.appendDummyInput().appendField(t.to('位置', 'position') + ':');
    ShapeSettings.setVR3Fields(block, 'position', 0, 1, 0);

    block.appendDummyInput().appendField(t.to('大きさ', 'scale') + ':');
    ShapeSettings.setVR3Fields(block, 'scale', 2, 1, 1);

    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string {
    let path = CodeSetting.getFieldValueWithoutEncode(block, 'path');
    // console.log('img_ path', path);

    if (path.trimLeft().startsWith('http')) {
      let proxyPath = '/img_proxy?url=';
      proxyPath += path.replace(/[?]/g, '__hatena__');
      proxyPath = proxyPath.replace(/[&]/g, '__amp__');
      path = proxyPath; // 置き換える
    }

    const id = CodeSetting.getFieldValue(block, 'id');

    let attribute = CodeSetting.getSubAttributeCode(block);
    // attribute +=  " src = '"  + path + "' ";
    // attribute +=  " id ='"  + id + "' ";
    attribute += CodeSetting.getAttributeCode('src', path);
    attribute += CodeSetting.getAttributeCode('id', id);
    attribute += CodeSetting.getVR3FieldValues(block, 'position');
    attribute += CodeSetting.getVR3FieldValues(block, 'scale');
    const str = CodeSetting.getElementCode(this.name_for_code, attribute, block.id, '');
    return str;
  }
}
